function RevParRoomReportMonthwise() {
    return (
      <>
        <div className="font-bold text-lg mb-16">RevParRoomReportMonthwise</div>
      </>
    );
  }
  
  export default RevParRoomReportMonthwise;